import forrest from "@onefront/forrestjs-core";
import reactRoot from "@onefront/forrestjs-react-root";

import { serviceAuth } from "./service-auth";
import { serviceAxios } from "./service-axios";
import { serviceEmbed } from "./service-embed";
import { serviceGainsight } from "./service-gainsight";
import { serviceGates } from "./service-gates";
import { serviceI18N } from "./service-i18n";
import { serviceLayout } from "./service-layout";
import { serviceNotistack } from "./service-notistack";
import { servicePushID } from "./service-pushid";
import { serviceRest } from "./service-rest";
import { serviceState } from "./service-state";
import { serviceVapor } from "./service-vapor";

// Export simple booting interface
export const OneFront = {
  run: ({
    settings = {},
    services = [],
    features = [],
    ...otherConfig
  } = {}) => {
    const one = settings.one || {};

    // Extrapolate the AppID with fallback on default DemoApp
    const appId =
      one.appId ||
      one.login?.target?.params
        ?.find(($) => $.includes("appId="))
        .split("=")[1] ||
      "app3000";

    const mergedSettings = {
      ...one,
      appId
    };
    settings.one = mergedSettings;

    return forrest.run({
      ...otherConfig,
      settings,
      services: [
        reactRoot,
        serviceState,
        servicePushID,
        serviceVapor,
        serviceNotistack,
        serviceAxios,
        serviceGates,
        serviceAuth,
        serviceRest,
        serviceLayout,
        serviceEmbed,
        serviceI18N,
        serviceGainsight,
        ...services
      ],
      features
    });
  }
};

export {
  AuthProvider,
  serviceAuth,
  useApplicationToken,
  useAuth,
  useDelegatedToken,
  useServiceLogin,
  useTokenData
} from "./service-auth";

export {
  serviceAxios,
  useAxios,
  useJumpUrl,
  useProxy,
  useTargetUrl
} from "./service-axios";

export {
  EMBED_CLOSE_MSG,
  EMBED_READY_MSG,
  EMBED_SELECT_MSG,
  EmbedIFrame,
  HostPage,
  serviceEmbed,
  useEmbedDrawer,
  useEmbedDrawerSelect,
  useEmbedPage,
  useEmbedPopover,
  useEmbedPopoverSelect,
  useHostPage
} from "./service-embed";

export {
  Trans,
  Translation,
  registryParse,
  registryRequest,
  serviceI18N,
  useTranslation,
  withTranslation
} from "./service-i18n";

export {
  LayoutContext,
  LayoutProvider,
  MenuProvider,
  serviceLayout,
  useHideSideNav,
  useLayout,
  useLayoutEmbed,
  useLayoutRoutes,
  useLayoutTitle,
  useLayoutToolbar,
  useMenu,
  useSideNavIsVisible,
  withHiddenSideNav,
  withSideNav
} from "./service-layout";

export { NotistackWrapper, useSnackbar } from "./service-notistack";

export { generatePushID, usePushID } from "./service-pushid";

export {
  serviceRest,
  useDelete,
  useGet,
  useMutation,
  usePost,
  usePut,
  useQuery,
  useRequest
} from "./service-rest";

export {
  useOneFrontStore,
  useStateSession,
  useStateStorage
} from "./service-state";

// Utils
export { useBrowserStorage } from "./utils/use-browser-storage";
export { useIsEmbed } from "./utils/use-is-embed";
export { useQueryString } from "./utils/use-query-string";

// Vapor
export { serviceVapor, useVaporTheme } from "./service-vapor";

// External
export { default as forrest } from "@onefront/forrestjs-core";
export {
  reactRoot,
  useGetConfig,
  useGetContext
} from "@onefront/forrestjs-react-root";
export { default as gql } from "graphql-tag";
export { useGainsightCustomEvent } from "./service-gainsight";

export default OneFront;
